module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/order-requisitions/order-requisitions/order-requisitions.component.scss
// module id = ./src/app/order-requisitions/order-requisitions/order-requisitions.component.scss
// module chunks = main